<template>
  <v-card>
    <v-card-title>
      Czy na pewno chcesz wycofać wykonane zmiany?
    </v-card-title>
    <v-card-text class="px-4">
      Po wycofaniu zmian zmiany, które dokonałeś na widoku, nie zostaną zapisane.
    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <fp-btn @click="() => closeModal(false)">
        Nie
      </fp-btn>
      <fp-btn primary @click="() => closeModal(true)">
        Tak
      </fp-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import {VueModalComponent} from 'fp-components';
import {ModalPayload} from '@/types/typings';
import { Component } from 'vue-property-decorator';

@Component({})
export default class RevertChangesModal extends VueModalComponent<ModalPayload<any>> {
}
</script>

<style scoped>

</style>
